import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

const AuthStrataCallback: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const hasHandledRef = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        if (hasHandledRef.current) {
          return;
        }
        hasHandledRef.current = true;

        await fetchAuthSession();
        await getCurrentUser();

        try {
          const storedPath = window.sessionStorage.getItem('postAuthRedirectPath');
          if (storedPath && storedPath.startsWith('/')) {
            window.sessionStorage.removeItem('postAuthRedirectPath');
            navigate(storedPath, { replace: true });
            return;
          }
        } catch (e) {
          console.error('Failed to read post-auth redirect path', e);
        }

        navigate('/requests', { replace: true });
      } catch (error) {
        console.error('Strata authentication error:', error);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return null;
};

export { AuthStrataCallback };
